// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"b08c91bc","189":"9486749c","250":"24a11951","331":"fd3d20e3","973":"c7fdda81"}[chunkId] + ".chunk.js";
};